import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "preferential_body"
};
const _hoisted_2 = {
  class: "preferential_body_nr"
};
const _hoisted_3 = {
  class: "preferential_list"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "item_top"
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  style: {
    "font-size": "100px",
    "font-weight": "bold"
  }
};
const _hoisted_8 = {
  key: 1,
  class: "case"
};
const _hoisted_9 = {
  style: {
    "font-size": "100px",
    "font-weight": "bold"
  }
};
const _hoisted_10 = {
  style: {
    "text-align": "center"
  }
};
const _hoisted_11 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[2] || (_cache[2] = _createElementVNode("h1", null, "领劵中心", -1)), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cardRecordsList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      onClick: $event => item.lock ? $setup.call() : ''
    }, [_createElementVNode("div", {
      style: _normalizeStyle('background:' + ($setup.designsObj[item.cardId]?.background ? 'url(' + $setup.designsObj[item.cardId].background + ')  center center / 100% 100% no-repeat;' : '#E7F6F9;'))
    }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
      style: _normalizeStyle('color:' + ($setup.designsObj[item.cardId]?.titleColor ? $setup.designsObj[item.cardId]?.titleColor : '#13A4BF'))
    }, [item.cardType == 'discount' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(item.discount), 1), _cache[0] || (_cache[0] = _createElementVNode("h1", {
      style: {
        "font-size": "24px",
        "margin-left": "7px",
        "display": "inline-block"
      }
    }, "折", -1))])) : (_openBlock(), _createElementBlock("div", _hoisted_8, [_cache[1] || (_cache[1] = _createElementVNode("span", {
      style: {
        "font-size": "40px"
      }
    }, "￥", -1)), _createElementVNode("span", _hoisted_9, _toDisplayString(item.reduceCost), 1)]))], 4), _createElementVNode("h3", {
      style: _normalizeStyle('color:' + ($setup.designsObj[item.cardId]?.bottomColor || '#000'))
    }, "有效期：****", 4)]), _createElementVNode("div", {
      class: "item_bot",
      style: _normalizeStyle('background:' + ($setup.designsObj[item.cardId] ? 'none;' : '#F3FAFC;'))
    }, [_createElementVNode("div", {
      style: _normalizeStyle([{
        "width": "90%",
        "display": "flex",
        "flex-direction": "column",
        "font-size": "16px",
        "position": "absolute",
        "top": "10px"
      }, 'color:' + ($setup.designsObj[item.cardId]?.dateColor || '#000')])
    }, [_createElementVNode("span", _hoisted_10, _toDisplayString(item.title), 1)], 4), !item.lock ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "btn",
      onClick: $event => $setup.getCoupon(item.cardId, item),
      style: _normalizeStyle('background:' + (item.unClaimable ? '#999' : $setup.designsObj[item.cardId]?.btnColor || '#13A4BF'))
    }, " 立即领取 ", 12, _hoisted_11)) : _createCommentVNode("", true)], 4)], 4)], 8, _hoisted_4);
  }), 128))])])]);
}